import {useEffect} from "react";
import { Outlet, Link } from "react-router-dom";
import { getTables } from "../bkend.js";

export default function Root() {
  useEffect(() => {
    document.title = 'Willowest management panel';
  }, []);

    return (
      <>
        <div id="sidebar">
          <h1>React Router Contacts</h1>
          <div>
            <form id="search-form" role="search">
              <input
                id="q"
                aria-label="Search contacts"
                placeholder="Search"
                type="search"
                name="q"
              />
              <div
                id="search-spinner"
                aria-hidden
                hidden={true}
              />
              <div
                className="sr-only"
                aria-live="polite"
              ></div>
            </form>
            <form method="post">
              <button type="submit">New</button>
            </form>
          </div>
          <nav>
            <ul>
                {
                    [
                        {name:'Your Name'}, 
                        {name:'Your Friend'}
                    ].map((item, idx)=><li>
                        <Link to={`detail/${idx}`}>{item.name}</Link>
                    </li>)
                }
            </ul>
          </nav>
        </div>
        <div id="detail">
            <Outlet />
        </div>
      </>
    );
  }